module.exports = __webpack_public_path__ + "static/img/K.073c321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/K.png
// module id = CPpy
// module chunks = 0